import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { TagModule } from 'primeng/tag';

import { SpeedDialModule } from 'primeng/speeddial';
import { MenuItem } from 'primeng/api';
import { CardModule } from 'primeng/card';

import { ILesson, ILessonWithTaken } from '../../lesson-mini-components/components/lessons.clases';
import { OnActionEvent } from '@dataclouder/ngx-core';

enum EventCard {
  Edit = 'edit',
  Delete = 'delete',
  Select = 'select',
  Qr = 'qr',
}
@Component({
  selector: 'dc-lesson-card',
  templateUrl: './dc-lesson-card.component.html',
  styleUrls: ['./dc-lesson-card.component.scss'],
  standalone: true,
  imports: [DatePipe, ButtonModule, PopoverModule, SpeedDialModule, CardModule, TagModule],
})
export class DcLessonCardComponent implements OnInit {
  @Input() lesson: ILessonWithTaken | ILesson | any;
  @Input() showOptions: boolean = true;
  @Input() cardHeight: string = '200px';

  @Output() onAction: EventEmitter<OnActionEvent> = new EventEmitter();

  public coverUrl: string = 'assets/background/default-background.webp';
  public eventType = EventCard;

  public items: MenuItem[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      command: () => {
        this.eventCard(EventCard.Edit);
      },
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      command: () => {
        this.eventCard(EventCard.Delete);
      },
    },
    {
      label: 'Tomar lección',
      icon: 'pi pi-play',
      command: () => {
        this.eventCard(EventCard.Select);
      },
    },
  ];

  ngOnInit() {
    this.coverUrl =
      this.lesson?.banner?.url || this.lesson?.metadata?.banner?.url || this.lesson?.media?.images?.[0]?.url || 'assets/background/default-background.webp';
  }

  public eventCard(eventType: EventCard) {
    switch (eventType) {
      case EventCard.Edit:
        this.onAction.emit({ action: 'edit', item: this.lesson });
        break;
      case EventCard.Delete:
        this.onAction.emit({ action: 'delete', item: this.lesson });
        break;
      case EventCard.Select:
        this.onAction.emit({ action: 'select', item: this.lesson });
        break;
      case EventCard.Qr:
        this.onAction.emit({ action: 'qr', item: this.lesson });
        break;
    }
  }
}
